import { Component } from "@angular/core";
import { Events } from "ionic-angular/util/events";
import { AlertController } from "ionic-angular/components/alert/alert-controller";
import { Whisky } from "../../data/whisky";
import { WhiskyDB } from "../../data/db";
import { NewWhiskyPage } from "../newWhisky/newWhisky";
import { ModalController } from "ionic-angular/components/modal/modal-controller";
import { ShowWhiskyPage } from "../showWhisky/showWhisky";
import { NavParams } from "ionic-angular/navigation/nav-params";
import { ToastController } from "ionic-angular/components/toast/toast-controller";
import { ViewController } from "ionic-angular/navigation/view-controller";

@Component({
  selector: "page-sublist",
  templateUrl: "sublist.html"
})
export class SublistPage {
  //lastFilter: any;
  whisky: Whisky[];
  limit = 20;
  allItems: Whisky[];

  newWhiskyPage: any;
  showWhiskyPage: any;
  loaded: boolean = false;

  sortType: string = "None";

  title = "";
  type = "";
  filter = "";
  URL = "";

  constructor(
    public events: Events,
    private alertCtrl: AlertController,
    private modalCtrl: ModalController,
    private navParams: NavParams,
    private toastCtrl: ToastController,
    private viewCtrl: ViewController
  ) {
    events.subscribe("whisky:updated", () => {
      console.log("got whisky:updated event");
      this.loaded = true;
      this.getItems();
      console.log("items " + this.whisky.length);
    });

    this.initializeItems();
    this.newWhiskyPage = NewWhiskyPage;
    this.showWhiskyPage = ShowWhiskyPage;
  }

  ionViewWillEnter() {
    this.title = this.navParams.get("title");
    this.type = this.navParams.get("type");
    this.URL = this.navParams.get("URL");
    console.log("URL=" + this.URL);
    console.log(this.title);
    console.log(this.type);
    this.filter = this.title;
    this.getItems();
  }

  initializeItems() {}

  getItems() {
    console.log("filtering " + WhiskyDB.whisky.length + " whiskies");
    this.allItems = WhiskyDB.whisky.filter(item => {
      switch (this.type) {
        case "distillery":
          return item.distillery === this.filter;
        case "bottler":
          return item.bottler === this.filter;
        case "shelf":
          return item.shelves[0] == this.filter;
        default:
          return false;
      }
    });

    console.log("found " + this.allItems.length);
    this.sortChanged();
  }

  sortChanged() {
    this.allItems = this.allItems.sort((a: Whisky, b: Whisky) => {
      return a.name.localeCompare(b.name);
    });
    this.limit = 20;
    this.whisky = this.allItems.slice(
      0,
      Math.min(this.limit, this.allItems.length)
    );
  }

  doInfinite(event: any) {
    //console.log("doInfinite");
    // Get next chunk from all filtered & sorted items
    let prior = this.limit;
    this.limit = this.limit + 20;
    //console.log("get more items: " + this.limit);
    this.limit = Math.min(this.limit, this.allItems.length);
    let moreItems = this.allItems.slice(prior, this.limit);

    moreItems.forEach(i => {
      this.whisky.push(i);
    });

    event.complete();
  }

  getSubHead(item: Whisky) {
    return item.distillery + " - " + item.region + " - " + item.rating;
  }
  getSubSubHead(item: Whisky) {
    if (item.bottler.length > 0) return item.bottler + " - " + item.shelves[0];
    return item.shelves[0];
  }
  select(e: any) {
    console.log("onClick " + e);
    let modal = this.modalCtrl.create(this.showWhiskyPage, { Whisky: e });
    modal.present();
  }

  addToCart(e: any, slider: any) {
    slider.close();
    console.log("addToCart " + e);
    WhiskyDB.basket.push(e);
    WhiskyDB.db.saveBasket();
    this.events.publish("basket:updated");
    let toast = this.toastCtrl.create({
      message: e.name + ' was added to the shopping list.',
      duration: 3000
    });
    toast.present();
    

  }

  dismiss()
  {
    this.viewCtrl.dismiss();
  }

  remove(toRemove: any, slider: any) {
    slider.close();
    let alert = this.alertCtrl.create({
      title: "Remove from collection?",
      subTitle: toRemove.name,
      cssClass: "removeAlert",
      buttons: [
        {
          text: "Cancel",
          role: "Cancel",
          handler: () => {
            console.log("Cancel remove");
          }
        },
        {
          text: "Remove",
          cssClass: "remove-button",
          handler: () => {
            // Remove selected items
            console.log("Remove: " + toRemove.name);
            // Remove is via a filter
            WhiskyDB.whisky = WhiskyDB.whisky.filter(item => {
              return item.name !== toRemove.name;
            });

            // Save them
            WhiskyDB.db.saveWhisky();
            this.events.publish("whisky:updated");
          }
        }
      ]
    });
    alert.present();
  }

  editItem(e: any, slider: any) {
    slider.close();
    console.log("edit " + e);
    let modal = this.modalCtrl.create(this.newWhiskyPage, { whisky: e });
    modal.present();    
  }
}



// WEBPACK FOOTER //
// ./src/pages/sublist/sublist.ts